import React, { memo, useCallback, useEffect, useState, useMemo, useRef } from "react";
import {
  Accordion,
  Button,
  Col,
  ProgressBar,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
// import { LinkWithTooltip } from "../../../onesource/data/staticData";
import { loader } from "../../../loader";
import { deleteData, postData, putData } from "../../../axios/apiHelper";
import { countryRegionArray } from "../../../Utils/Country";
import { LinkWithTooltip } from "../../Library/R&D/StaticData";

export const TrashIcon = React.memo(({ deleteButtonColor }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.84 22.25H8.15989C7.3915 22.2389 6.65562 21.9381 6.09941 21.4079C5.5432 20.8776 5.20765 20.157 5.15985 19.39L4.24984 5.55C4.24518 5.44966 4.26045 5.34938 4.29478 5.25498C4.32911 5.16057 4.38181 5.07391 4.44985 5C4.51993 4.9234 4.60479 4.86177 4.69931 4.81881C4.79382 4.77584 4.89606 4.75244 4.99985 4.75H19C19.1029 4.74977 19.2046 4.7707 19.2991 4.81148C19.3935 4.85226 19.4785 4.91202 19.5488 4.98704C19.6192 5.06207 19.6733 5.15077 19.7079 5.24761C19.7426 5.34446 19.7569 5.44739 19.75 5.55L18.88 19.39C18.8317 20.1638 18.4905 20.8902 17.9258 21.4214C17.3611 21.9527 16.6153 22.249 15.84 22.25ZM5.83986 6.25L6.60987 19.3C6.63531 19.6935 6.80978 20.0625 7.09775 20.3319C7.38573 20.6013 7.76555 20.7508 8.15989 20.75H15.84C16.2336 20.7485 16.6121 20.5982 16.8996 20.3292C17.1871 20.0603 17.3622 19.6927 17.39 19.3L18.2 6.3L5.83986 6.25Z"
        fill={deleteButtonColor}
      />
      <path
        d="M20.9998 6.25H2.99999C2.80108 6.25 2.61032 6.17098 2.46967 6.03033C2.32902 5.88968 2.25 5.69891 2.25 5.5C2.25 5.30109 2.32902 5.11032 2.46967 4.96967C2.61032 4.82902 2.80108 4.75 2.99999 4.75H20.9998C21.1987 4.75 21.3895 4.82902 21.5301 4.96967C21.6708 5.11032 21.7498 5.30109 21.7498 5.5C21.7498 5.69891 21.6708 5.88968 21.5301 6.03033C21.3895 6.17098 21.1987 6.25 20.9998 6.25Z"
        fill={deleteButtonColor}
      />
      <path
        d="M15 6.25009H9C8.80189 6.2475 8.61263 6.16765 8.47253 6.02755C8.33244 5.88745 8.25259 5.69819 8.25 5.50007V3.70004C8.26268 3.18685 8.47219 2.69818 8.83518 2.33519C9.19816 1.9722 9.68682 1.76268 10.2 1.75H13.8C14.3217 1.76305 14.8177 1.97951 15.182 2.35319C15.5463 2.72686 15.7502 3.22815 15.75 3.75004V5.50007C15.7474 5.69819 15.6676 5.88745 15.5275 6.02755C15.3874 6.16765 15.1981 6.2475 15 6.25009ZM9.75 4.75006H14.25V3.75004C14.25 3.63069 14.2026 3.51623 14.1182 3.43184C14.0338 3.34744 13.9193 3.30003 13.8 3.30003H10.2C10.0807 3.30003 9.96619 3.34744 9.8818 3.43184C9.79741 3.51623 9.75 3.63069 9.75 3.75004V4.75006Z"
        fill={deleteButtonColor}
      />
      <path
        d="M15 18.25C14.8019 18.2474 14.6126 18.1676 14.4725 18.0275C14.3324 17.8874 14.2526 17.6981 14.25 17.5V9.5C14.25 9.30109 14.329 9.11032 14.4697 8.96967C14.6103 8.82902 14.8011 8.75 15 8.75C15.1989 8.75 15.3897 8.82902 15.5303 8.96967C15.671 9.11032 15.75 9.30109 15.75 9.5V17.5C15.7474 17.6981 15.6676 17.8874 15.5275 18.0275C15.3874 18.1676 15.1981 18.2474 15 18.25Z"
        fill={deleteButtonColor}
      />
      <path
        d="M9 18.25C8.80189 18.2474 8.61263 18.1676 8.47253 18.0275C8.33244 17.8874 8.25259 17.6981 8.25 17.5V9.5C8.25 9.30109 8.32902 9.11032 8.46967 8.96967C8.61032 8.82902 8.80109 8.75 9 8.75C9.19891 8.75 9.38968 8.82902 9.53033 8.96967C9.67098 9.11032 9.75 9.30109 9.75 9.5V17.5C9.74741 17.6981 9.66756 17.8874 9.52747 18.0275C9.38737 18.1676 9.19811 18.2474 9 18.25Z"
        fill={deleteButtonColor}
      />
      <path
        d="M12 18.25C11.8019 18.2474 11.6126 18.1676 11.4725 18.0275C11.3324 17.8874 11.2526 17.6981 11.25 17.5V9.5C11.25 9.30109 11.329 9.11032 11.4697 8.96967C11.6103 8.82902 11.8011 8.75 12 8.75C12.1989 8.75 12.3897 8.82902 12.5303 8.96967C12.671 9.11032 12.75 9.30109 12.75 9.5V17.5C12.7474 17.6981 12.6676 17.8874 12.5275 18.0275C12.3874 18.1676 12.1981 18.2474 12 18.25Z"
        fill={deleteButtonColor}
      />
    </svg>
  );
});

export default function VwdProfile() {
  const navigate = useNavigate();
  const buttonRef = useRef(null);
  const filterRef = useRef(null);
  const [readerAllData, setReaderAllData] = useState([]);
  const [allCountries, setAllCountries] = useState(
    Object.keys(countryRegionArray).sort((a, b) => a.localeCompare(b)),
  );
  const [search, setSearch] = useState("");
  const [isDelete, setIsDelete] = useState(false);
  const searchRef = useRef();
  const initialFilters = useMemo(
    () => ({
      type: [],
      region: [],
      country: [],
      status: [],
      company: [],
      role: "",
    }),
    [],
  );
  const [appliedFilter, setAppliedFilter] = useState(initialFilters);
  const [draftFilter, setDraftFilter] = useState(initialFilters);
  const [showFilter, setShowFilter] = useState(false);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        loader("show");
        const response = await postData("/vwd/get-user-list", {});
        if (response?.status === 200) {
          setReaderAllData(response?.data?.data || []);
        }
      } catch (err) {
        console.log("Error while fetching user data : ", err);
      } finally {
        loader("hide");
      }
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        buttonRef.current &&
        !buttonRef.current.contains(event.target) &&
        filterRef.current &&
        !filterRef.current.contains(event.target)
      ) {
        setShowFilter(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  const filterOptions = useMemo(() => {
    const getUniqueSorted = (key) => {
      return [
        ...new Set(
          readerAllData
            .map((reader) => reader?.[key]?.trim?.() || "")
            .filter((value) => Boolean(value)),
        ),
      ].sort((a, b) => a.localeCompare(b));
    };

    return {
      type: getUniqueSorted("type"),
      region: getUniqueSorted("region"),
      country: getUniqueSorted("country"),
      status: getUniqueSorted("userStatus"),
      company: getUniqueSorted("company"),
      role: getUniqueSorted("role"),
    };
  }, [readerAllData]);

  const hasAppliedFilter = useMemo(() => {
    return (
      appliedFilter.type.length > 0 ||
      appliedFilter.region.length > 0 ||
      appliedFilter.country.length > 0 ||
      appliedFilter.status.length > 0 ||
      appliedFilter.company.length > 0 ||
      appliedFilter.role.length > 0
    );
  }, [appliedFilter]);

  const readerData = useMemo(() => {
    let data = [...readerAllData];
    const searchText = search.toLowerCase().trim();

    data = data.filter((reader) => {
      const readerName = reader?.name?.toLowerCase().trim() || "";
      const readerRole = reader?.role?.toLowerCase().trim() || "";

      if (searchText && !readerName.includes(searchText)) return false;
      if (
        appliedFilter.type.length > 0 &&
        !appliedFilter.type.includes(reader?.type)
      )
        return false;
      if (
        appliedFilter.region.length > 0 &&
        !appliedFilter.region.includes(reader?.region)
      )
        return false;
      if (
        appliedFilter.country.length > 0 &&
        !appliedFilter.country.includes(reader?.country)
      )
        return false;
      if (
        appliedFilter.status.length > 0 &&
        !appliedFilter.status.includes(reader?.userStatus)
      )
        return false;
      if (
        appliedFilter.company.length > 0 &&
        !appliedFilter.company.includes(reader?.company)
      )
        return false;
      if (
        appliedFilter.role.length > 0 &&
        !appliedFilter.role.includes(reader?.role)
      )
        return false;

      return true;
    });

    return data;
  }, [appliedFilter, readerAllData, search]);

  const handleSearch = useCallback((e) => {
    e.preventDefault();
    setSearch(searchRef.current.value.trim());
  });

  const handleInputChange = useCallback((e) => {
    e.preventDefault();
    if (!searchRef.current.value.trim()) handleSearch(e);
  });

  const handleFilterSelection = useCallback((key, value) => {
    setDraftFilter((prev) => {
      const selectedValues = prev[key] || [];
      const isSelected = selectedValues.includes(value);
      return {
        ...prev,
        [key]: isSelected
          ? selectedValues.filter((item) => item !== value)
          : [...selectedValues, value],
      };
    });
  }, []);

  const handleRoleFilterChange = useCallback((e) => {
    setDraftFilter((prev) => ({ ...prev, role: e.target.value }));
  }, []);

  const clearFilter = useCallback(() => {
    setDraftFilter(initialFilters);
    setAppliedFilter(initialFilters);
  }, [initialFilters]);

  const applyFilter = useCallback(() => {
    setAppliedFilter(draftFilter);
    setShowFilter(false);
  }, [draftFilter]);

  return (
    <>
      <Col className="right-sidebar custom-change vwd-profile-dashboard">
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <div className="custom-container">
          <Row>
            <div className="top-sticky">
              <div className="top-header reader_list">
                <div className="page-title">
                  <h4>Profile</h4>
                </div>
                <div class="top-right-action flex-wrap">
                  <div class="action-btn-add" style={{ margin: "0px" }}>
                    <button
                      type="button"
                      class="btn-dashed btn btn-primary"
                      onClick={() => navigate("/vwd/invite-user")}
                    >
                      Invite User
                      <img
                        src="https://informed.pro/componentAssets/images/add-irt.png"
                        alt=""
                      />
                    </button>
                  </div>
                  <div className="search-bar">
                    <form className="d-flex" onSubmit={handleSearch}>
                      <input
                        className="form-control me-2"
                        type="search"
                        placeholder="Search by user name"
                        aria-label="Search"
                        id="email_search"
                        ref={searchRef}
                        onChange={handleInputChange}
                      />
                      <button className="btn btn-outline" type="submit">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.8045 14.862L11.2545 10.312C12.1359 9.22334 12.6665 7.84 12.6665 6.33334C12.6665 2.84134 9.82522 0 6.33325 0C2.84128 0 0 2.84131 0 6.33331C0 9.82531 2.84132 12.6667 6.33328 12.6667C7.83992 12.6667 9.22325 12.136 10.3119 11.2547L14.8619 15.8047C14.9919 15.9347 15.1625 16 15.3332 16C15.5039 16 15.6745 15.9347 15.8045 15.8047C16.0652 15.544 16.0652 15.1227 15.8045 14.862ZM6.33328 11.3333C3.57597 11.3333 1.33333 9.09066 1.33333 6.33331C1.33333 3.57597 3.57597 1.33331 6.33328 1.33331C9.0906 1.33331 11.3332 3.57597 11.3332 6.33331C11.3332 9.09066 9.09057 11.3333 6.33328 11.3333Z"
                            fill="#97B6CF"
                          ></path>
                        </svg>
                      </button>
                    </form>
                  </div>
                  <div className="filter-by nav-item dropdown">
                    <button
                      ref={buttonRef}
                      className={
                        hasAppliedFilter
                          ? "btn btn-secondary dropdown filter_applied"
                          : "btn btn-secondary dropdown"
                      }
                      type="button"
                      id="dropdownMenuButton2"
                      onClick={() => setShowFilter((prev) => !prev)}
                    >
                      Filter By
                      {showFilter ? (
                        <svg
                          className="close-arrow"
                          width="13"
                          height="12"
                          viewBox="0 0 13 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            width="2.09896"
                            height="15.1911"
                            rx="1.04948"
                            transform="matrix(0.720074 0.693897 -0.720074 0.693897 11.0977 0)"
                            fill="#0066BE"
                          />
                          <rect
                            width="2.09896"
                            height="15.1911"
                            rx="1.04948"
                            transform="matrix(0.720074 -0.693897 0.720074 0.693897 0 1.45898)"
                            fill="#0066BE"
                          />
                        </svg>
                      ) : (
                        <svg
                          className="filter-arrow"
                          width="16"
                          height="14"
                          viewBox="0 0 16 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.615385 2.46154H3.07692C3.07692 3.14031 3.62892 3.69231 4.30769 3.69231H5.53846C6.21723 3.69231 6.76923 3.14031 6.76923 2.46154H15.3846C15.7243 2.46154 16 2.18646 16 1.84615C16 1.50585 15.7243 1.23077 15.3846 1.23077H6.76923C6.76923 0.552 6.21723 0 5.53846 0H4.30769C3.62892 0 3.07692 0.552 3.07692 1.23077H0.615385C0.275692 1.23077 0 1.50585 0 1.84615C0 2.18646 0.275692 2.46154 0.615385 2.46154Z"
                            fill="#97B6CF"
                          />
                          <path
                            d="M15.3846 6.15362H11.6923C11.6923 5.47485 11.1403 4.92285 10.4615 4.92285H9.23077C8.552 4.92285 8 5.47485 8 6.15362H0.615385C0.275692 6.15362 0 6.4287 0 6.76901C0 7.10931 0.275692 7.38439 0.615385 7.38439H8C8 8.06316 8.552 8.61516 9.23077 8.61516H10.4615C11.1403 8.61516 11.6923 8.06316 11.6923 7.38439H15.3846C15.7243 7.38439 16 7.10931 16 6.76901C16 6.4287 15.7243 6.15362 15.3846 6.15362Z"
                            fill="#97B6CF"
                          />
                          <path
                            d="M15.3846 11.077H6.76923C6.76923 10.3982 6.21723 9.84619 5.53846 9.84619H4.30769C3.62892 9.84619 3.07692 10.3982 3.07692 11.077H0.615385C0.275692 11.077 0 11.352 0 11.6923C0 12.0327 0.275692 12.3077 0.615385 12.3077H3.07692C3.07692 12.9865 3.62892 13.5385 4.30769 13.5385H5.53846C6.21723 13.5385 6.76923 12.9865 6.76923 12.3077H15.3846C15.7243 12.3077 16 12.0327 16 11.6923C16 11.352 15.7243 11.077 15.3846 11.077Z"
                            fill="#97B6CF"
                          />
                        </svg>
                      )}
                    </button>
                    {showFilter && (
                      <div
                        ref={filterRef}
                        className="dropdown-menu filter-options crm-filter"
                        aria-labelledby="dropdownMenuButton2"
                      >
                        <h4>Filter By</h4>
                        <div className="filter-option">
                          <Accordion defaultActiveKey="0" flush>
                            {[
                              { key: "type", label: "Type" },
                              { key: "region", label: "Region" },
                              { key: "country", label: "Country" },
                              { key: "status", label: "Status" },
                              { key: "company", label: "Company" },
                              { key: "role", label: "Role" },
                            ].map((item, index) => (
                              <Accordion.Item
                                className="card"
                                eventKey={`${index}`}
                                key={item.key}
                              >
                                <Accordion.Header
                                  className={`card-header ${
                                    draftFilter[item.key]?.length
                                      ? "selected"
                                      : ""
                                  }`}
                                >
                                  {item.label}
                                </Accordion.Header>
                                <Accordion.Body className="card-body">
                                  <ul>
                                    {filterOptions[item.key]?.map((value) => (
                                      <li key={value}>
                                        <label className="select-multiple-option">
                                          <input
                                            type="checkbox"
                                            value={value}
                                            checked={draftFilter[
                                              item.key
                                            ]?.includes(value)}
                                            onChange={() =>
                                              handleFilterSelection(
                                                item.key,
                                                value,
                                              )
                                            }
                                          />
                                          {value}
                                          <span className="checkmark"></span>
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </Accordion.Body>
                              </Accordion.Item>
                            ))}
                          </Accordion>
                        </div>

                        <div className="filter-footer">
                          <Button
                            className="btn btn-primary btn-bordered"
                            onClick={clearFilter}
                          >
                            Clear
                          </Button>
                          <Button
                            className="btn btn-primary btn-filled"
                            onClick={applyFilter}
                          >
                            Apply
                          </Button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="clear-search">
                    {isDelete ? (
                      <button
                        className="btn btn-outline-primary cancel"
                        title="Cancel delete"
                        onClick={() => setIsDelete((prev) => !prev)}
                      >
                        Cancel
                      </button>
                    ) : (
                      <button
                        // className="btn btn-outline-primary"
                        title="Delete"
                        onClick={() => setIsDelete((prev) => !prev)}
                        className="btn btn-outline-primary"
                      >
                        <TrashIcon deleteButtonColor={"#0066be"} />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="library-content-box-layuot readerlist d-flex">
              <h4 className="total-card">
                Total |{" "}
                <span>
                  {readerData && Array.isArray(readerData)
                    ? readerData.length
                    : 0}
                </span>
              </h4>
              {/* CARD 1 */}
              {readerData?.length ? (
                readerData?.map((reader, index) => {
                  return (
                    <ReaderCard
                      key={index}
                      index={index}
                      reader={reader}
                      allCountries={allCountries}
                      setReaderAllData={setReaderAllData}
                      isDelete={isDelete}
                    />
                  );
                })
              ) : (
                <div class="email_box_block no_found rd">
                  <p>No Data Found</p>
                </div>
              )}
            </div>
          </Row>
        </div>
      </Col>
    </>
  );
}

const ReaderCard = memo(
  ({ reader, allCountries, index, setReaderAllData, isDelete }) => {
    let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
    const navigate = useNavigate();
    const [country, setCountry] = useState("");
    const [isInternal, setIsInternal] = useState(false);
    const [isIbt, setIsIbt] = useState(reader?.ibt === 1 ? true : false);
    const [usageData, setUsageData] = useState({ loading: false, data: {} });
    const userstatus = {
      "Access Requested": "access",
      Active: "active",
      Rejected: "rejected",
      Blocked: "blocked",
      Deleted: "deleted",
      Invited: "invite",
    };
    const statusTooltip = {
      "Access Requested":
        "User has requested access to the platform and is awaiting approval",
      Active: "User who currently has access to the platform",
      Rejected: "User's access request was reviewed and not approved",
      Blocked: "User whose access to the platform has been restricted",
      Deleted: "User account has been removed from the platform",
      Invited:
        "User who has received an invitation to access the platform but has not logged in yet",
    };

    useEffect(() => {
      setIsInternal(reader.type === "Internal");
      setIsIbt(reader.ibt);
      setCountry({ label: reader.country, value: reader.country });
    }, [reader]);

    const formatDate = useCallback((dateStr) => {
      const date = new Date(dateStr);
      const formattedDate = date
        .toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
        .replace(/ /g, ". ");
      return formattedDate;
    }, []);

    const handleUpdateClick = useCallback(async () => {
      if (
        Boolean(reader.ibt) !== Boolean(isIbt) ||
        country.value !== reader.country
      ) {
        try {
          loader("show");
          const payload = {
            id: reader.id,
            name: reader.name,
            ibt: Boolean(isIbt),
            country: country.value,
            region: reader.region,
            company: reader.company,
            role: reader.role,
          };

          await putData("/vwd/update-user-data", payload);
          setReaderAllData((prev) => {
            return prev.map((r) => {
              if (r.id === reader.id)
                return { ...r, ibt: isIbt ? 1 : 0, country: country.value };
              else return r;
            });
          });
        } catch (err) {
          console.log("Error while updating user data : ", err);
        } finally {
          loader("hide");
        }
      }
    }, [country, isIbt, reader]);

    const getUsageData = useCallback(() => {
      setUsageData({ loading: true, data: {} });

      postData("/reader/reader-activity", {
        readerId: reader.user_id,
        irt: 0,
        "Content Owners": [],
        from_vwd : true
      })
        .then((response) => {
          if (response?.status === 200) {
            const data = response?.data?.data || {};
            setUsageData({ loading: false, data });
          }
        })
        .catch((err) => {
          console.log("Error while fetching reader activity data : ", err);
          setUsageData({ loading: false, data: {} });
        });
    }, [reader]);

    const handleTabChange = useCallback(
      (key) => {
        if (key === "usage" && Object.keys(usageData.data).length === 0) {
          getUsageData();
        }
      },
      [getUsageData, usageData],
    );

    const handleDeleteProfile = useCallback(() => {
      loader("show");
      deleteData(`/vwd/delete-user-profile`, reader.id)
        .then((response) => {
          if (response?.status === 200) {
            setReaderAllData((prev) => prev.filter((r) => r.id !== reader.id));
          }
          loader("hide");
        })
        .catch((err) => {
          loader("hide");

          console.log("Error while deleting user profile : ", err);
        });
    }, [reader]);

    return (
      <div className="doc-content-main-box col">
        {reader?.ibt === 1 ? (
          <img
            src={path_image + "ibt-badge.png"}
            alt="badge"
            className="corner-badge-img"
          />
        ) : null}
        <div className="doc-content-header">
          <div className="doc-content">
            <h4>{reader?.name || "-"}</h4>
          </div>
        </div>
        <div className="tabs-data">
          <Tabs
            defaultActiveKey="personal-details"
            onSelect={handleTabChange}
            fill
          >
            {/* PERSONAL DETAILS */}
            <Tab
              eventKey="personal-details"
              title="Personal Details"
              className="flex-column justify-content-between"
            >
              <div className="tab-panel d-flex flex-column justify-content-between">
                <ul className="tab-mail-list">
                  <li>
                    <h6 className="tab-content-title">Email</h6>
                    <h6>{reader?.email || "-"}</h6>
                  </li>

                  <li>
                    <h6 className="tab-content-title">Type</h6>
                    <h6>{reader?.type || "-"}</h6>
                  </li>

                  <li>
                    <h6 className="tab-content-title">Role</h6>
                    <h6>{reader?.role || "-"}</h6>
                  </li>

                  <li>
                    <h6 className="tab-content-title">Company</h6>
                    <h6>{reader?.company || "-"}</h6>
                  </li>
                  <li>
                    <h6 className="tab-content-title">Region</h6>
                    <h6>{reader?.region || "-"}</h6>
                  </li>
                  <li>
                    <h6 className="tab-content-title">Country</h6>
                    <h6>{reader?.country || "-"}</h6>
                  </li>
                  <li>
                    <h6 className="tab-content-title">Status</h6>
                    <h6 className={userstatus[reader?.userStatus]}>
                      {reader?.userStatus || "-"}

                      <LinkWithTooltip
                        tooltip={
                          statusTooltip[reader?.userStatus] ||
                          "Status not available"
                        }
                        // href="#"
                      >
                        <img
                          src={path_image + "info_circle_icon.svg"}
                          alt="info"
                        />
                      </LinkWithTooltip>
                    </h6>
                  </li>
                  <li>
                    <h6 className="tab-content-title">Join Date</h6>
                    <h6>
                      {reader?.created && reader.created !== "N/A"
                        ? formatDate(reader.created)
                        : "-"}
                    </h6>
                  </li>
                  <li>
                    <h6 className="tab-content-title">Last Activity</h6>
                    <h6>
                      {reader?.lastActivity
                        ? formatDate(reader?.lastActivity)
                        : "-"}
                    </h6>
                  </li>
                </ul>
              </div>

              <div className="data-main-footer-sec">
                <div className="data-main-footer-sec-inner invest">
                  <div className="footer-btn d-flex justify-content-between">
                    <button
                      className="btn btn-primary btn-bordered"
                      onClick={() =>
                        navigate("/vwd/edit-profile", {
                          state: {
                            id: reader.id,
                            action: "edit",
                          },
                        })
                      }
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-primary btn-filled profile-view"
                      onClick={() =>
                        navigate("/vwd/view-profile", {
                          state: { id: reader.id,user_id: reader.user_id },
                        })
                      }
                    >
                      View profile
                    </button>
                  </div>
                </div>
              </div>
            </Tab>

            {/* USAGE TAB */}
            <Tab
              eventKey="usage"
              title="Usage"
              className="flex-column justify-content-between"
            >
              <div className="data-main-box tab-panel d-flex flex-column justify-content-between">
                <ul className="tab-mail-list data">
                  <li>
                    <h6 className="tab-content-title">
                      Emails sent
                      <LinkWithTooltip tooltip="Number of emails sent to this user">
                        <img
                          src={path_image + "info_circle_icon.svg"}
                          alt="info"
                        />
                      </LinkWithTooltip>
                    </h6>
                    <div className="data-progress send">
                      <ProgressBar
                        now={100}
                        label={
                          usageData?.loading
                            ? "Loading"
                            : usageData?.data?.emailSent
                        }
                      />
                    </div>
                  </li>

                  <li>
                    <h6 className="tab-content-title">
                      Emails opened
                      <LinkWithTooltip tooltip="Number of emails opened by this user">
                        <img
                          src={path_image + "info_circle_icon.svg"}
                          alt="info"
                        />
                      </LinkWithTooltip>
                    </h6>
                    <div className="data-progress open">
                      <ProgressBar
                        now={60}
                        label={
                          usageData?.loading
                            ? "Loading"
                            : usageData?.data?.emailOpen
                        }
                      />
                    </div>
                  </li>

                  <li>
                    <h6 className="tab-content-title">
                      Content with RTR
                      <LinkWithTooltip tooltip="Number of unique content where HCP have read little or a lot">
                        <img
                          src={path_image + "info_circle_icon.svg"}
                          alt="info"
                        />
                      </LinkWithTooltip>
                    </h6>
                    <div className="data-progress delivered">
                      <ProgressBar
                        now={40}
                        label={
                          usageData?.loading ? "Loading" : usageData?.data?.rtr
                        }
                      />
                    </div>
                  </li>

                  <li>
                    <h6 className="tab-content-title">
                      Content openings
                      <LinkWithTooltip tooltip="Total number of article opening">
                        <img
                          src={path_image + "info_circle_icon.svg"}
                          alt="info"
                        />
                      </LinkWithTooltip>
                    </h6>
                    <div className="data-progress webinar-registered rtr">
                      <ProgressBar
                        now={30}
                        label={
                          usageData?.loading
                            ? "Loading"
                            : usageData?.data?.contentOpening
                        }
                      />
                    </div>
                  </li>
                  <li>
                    <h6 className="tab-content-title">
                      Content shared
                      <LinkWithTooltip tooltip="Total number of times content has been shared by this user">
                        <img
                          src={path_image + "info_circle_icon.svg"}
                          alt="info"
                        />
                      </LinkWithTooltip>
                    </h6>
                    <div className="data-progress webinar-registered qr-opening">
                      <ProgressBar
                        now={30}
                        label={
                          usageData?.loading
                            ? "Loading"
                            : usageData?.data?.contentShared
                        }
                      />
                    </div>
                  </li>
                  <li>
                    <h6 className="tab-content-title">
                      Content downloaded
                      <LinkWithTooltip tooltip="Total number of content downloads by this user">
                        <img
                          src={path_image + "info_circle_icon.svg"}
                          alt="info"
                        />
                      </LinkWithTooltip>
                    </h6>
                    <div className="data-progress webinar-registered go-opening">
                      <ProgressBar
                        now={30}
                        label={
                          usageData?.loading
                            ? "Loading"
                            : usageData?.data?.contentDownloaded
                        }
                      />
                    </div>
                  </li>
                  <li>
                    <h6 className="tab-content-title">
                      Content liked
                      <LinkWithTooltip tooltip="Total number of content likes by this user">
                        <img
                          src={path_image + "info_circle_icon.svg"}
                          alt="info"
                        />
                      </LinkWithTooltip>
                    </h6>
                    <div className="data-progress webinar-registered content-opening">
                      <ProgressBar
                        now={30}
                        label={
                          usageData?.loading
                            ? "Loading"
                            : usageData?.data?.contentLiked
                        }
                      />
                    </div>
                  </li>
                  <li className="last-activity">
                    <h6 className="tab-content-title">
                      Last content activity
                      <LinkWithTooltip tooltip="Last activity performed related to content by this user">
                        <img
                          src={path_image + "info_circle_icon.svg"}
                          alt="info"
                        />
                      </LinkWithTooltip>
                    </h6>
                    <div className="data-progress content-opening">
                      <ProgressBar
                        now={70}
                        label={
                          usageData?.loading
                            ? "Loading"
                            : usageData?.data?.LastActivity === "N/A"
                              ? "N/A"
                              : usageData?.data?.LastActivity?.replaceAll(
                                  " ",
                                  ". ",
                                )
                        }
                      />
                    </div>
                  </li>
                </ul>
              </div>
              <div className="data-main-footer-sec">
                <div className="data-main-footer-sec-inner">
                  <div className="footer-btn d-flex justify-content-end">
                    <button className="btn btn-primary btn-bordered">
                      See time line
                    </button>
                  </div>
                </div>
              </div>
            </Tab>

            {/* CHANGE TAB */}
            <Tab eventKey="change-tab" title="Change">
              <div className="data-main-box change-tab-main-box flex-column d-flex">
                <ul className="tab-mail-list data change">
                  <li>
                    <h6 className="tab-content-title">IBT</h6>
                    <div className="select-dropdown-wrapper">
                      <fieldset id="group6">
                        <div className="switch">
                          <label className="switch-light">
                            <input
                              type="checkbox"
                              name="group6"
                              checked={isIbt}
                              onChange={(e) => {
                                setIsIbt(e.target.checked);
                              }}
                            />
                            <span>
                              <span
                                className={`switch-btn ${isIbt ? " Active" : ""}`}
                              >
                                No
                              </span>
                              <span
                                className={`switch-btn ${
                                  !isIbt ? " Active" : ""
                                }`}
                              >
                                Yes
                              </span>
                            </span>
                            <a className="btn"></a>
                          </label>
                        </div>
                      </fieldset>
                    </div>
                  </li>
                  <li>
                    <h6 className="tab-content-title">Type</h6>
                    <div className="select-dropdown-wrapper">
                      <fieldset>
                        <input
                          type="radio"
                          checked={isInternal}
                          onClick={(e) => setIsInternal(e.target.checked)}
                          id={"limitagreed2" + index}
                          disabled={!isInternal}
                        />
                        <label htmlFor="limitagreed2">Internal</label>

                        <input
                          type="radio"
                          checked={!isInternal}
                          onClick={(e) => setIsInternal(!e.target.checked)}
                          id={"limitagreed1" + index}
                          disabled={isInternal}
                        />
                        <label htmlFor="limitagreed1">External</label>
                      </fieldset>
                    </div>
                  </li>
                  <li>
                    <h6 className="tab-content-title">Country</h6>
                    <div className="select-dropdown-wrapper">
                      <div className="select">
                        <Select
                          options={allCountries.map((c) => ({
                            label: c,
                            value: c,
                          }))}
                          value={country}
                          onChange={setCountry}
                          className="dropdown-basic-button split-button-dropup"
                          isClearable
                        />
                      </div>
                    </div>
                  </li>
                </ul>
                <div className="data-main-footer-sec">
                  <div className="footer-btn vwd-update-btn">
                    <button
                      className="btn btn-primary btn-filled update"
                      onClick={handleUpdateClick}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </Tab>
          </Tabs>
        </div>
        {isDelete && (
          <div class="data-main-footer-sec">
            <div class="dlt_btn">
              <button onClick={handleDeleteProfile}>
                <img
                  src="/componentAssets/images/delete.svg"
                  alt="Delete Row"
                />
              </button>
            </div>
          </div>
        )}
      </div>
    );
  },
);
